import React from 'react';
import {
  Box,
  Button,
  Card,
  CardContent,
  CircularProgress,
  IconButton,
  TextField,
  Typography,
} from '@mui/material';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';

export default function EditableTaskTextCard({
  label,
  value,
  active,
  draft,
  onDraftChange,
  onEdit,
  onCancel,
  onSave,
  saving,
  multiline = false,
  minRows = 2,
  valueTypographyProps,
  editorInputSx,
}) {
  return (
    <Card variant="outlined" sx={{ borderRadius: 2, mb: 1.5 }}>
      <CardContent sx={{ p: 2 }}>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', gap: 1.5, alignItems: 'flex-start' }}>
          <Box sx={{ flex: 1, minWidth: 0 }}>
            {active ? (
              <>
                <TextField
                  fullWidth
                  variant="standard"
                  label={label}
                  value={draft}
                  onChange={(e) => onDraftChange(e.target.value)}
                  multiline={multiline}
                  minRows={multiline ? minRows : undefined}
                  InputProps={{
                    disableUnderline: true,
                    sx: editorInputSx,
                  }}
                />
                <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 1, mt: 1.5 }}>
                  <Button size="small" onClick={onCancel}>
                    Cancel
                  </Button>
                  <Button size="small" variant="contained" onClick={onSave} disabled={saving}>
                    {saving ? <CircularProgress size={16} color="inherit" /> : 'Update'}
                  </Button>
                </Box>
              </>
            ) : (
              <>
                <Typography variant="caption" color="text.secondary">
                  {label}
                </Typography>
                <Typography
                  sx={{
                    mt: 0.5,
                    wordBreak: 'break-word',
                    whiteSpace: multiline ? 'pre-wrap' : 'normal',
                  }}
                  {...valueTypographyProps}
                >
                  {value || '—'}
                </Typography>
              </>
            )}
          </Box>
          {!active ? (
            <IconButton size="small" onClick={onEdit} sx={{ color: 'primary.main', mt: -0.25 }}>
              <EditOutlinedIcon fontSize="small" />
            </IconButton>
          ) : null}
        </Box>
      </CardContent>
    </Card>
  );
}
